<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>
<div class="row">
  <div class="menu-container">
    <div class="row menu-row-container">
      <div class="col-sm-8 gridName-container">
        <span class="gridName">Assessment Questions</span>
      </div>
    </div>
  </div>
</div>
<div class="table-container">
  <div id="header-container" class="d-flex justify-content-end gap-3 mt-1 mb-3">
    <div class="">
      <div class="search-container">
        <input type="text" class="form-control search_input" style="font-size: 13px;" placeholder="Search"
          [(ngModel)]="searchValue">
      </div>
    </div>

    <div class="">
      <div class="d-flex gap-2 action-buttons-container">
        <div *ngIf="contentData.saveButtonForTraining"
          class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="addQuestionFunc($event)" (keydown.enter)="addQuestionFunc($event)" matTooltip="Add Question">
          <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
          <span class="reload_text text-white">Add New</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="openReport('Excel')" (keydown.enter)="openReport('Excel')">
          <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">Excel Report</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="openReport('Pdf')"
          (keydown.enter)="openReport('Pdf')">
          <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">PDF Report</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          *ngIf="message.isAuditTrailUser" (click)="openAuditTrail('overAll',0)"
          (keydown.enter)="openAuditTrail('overAll',0)" matTooltip="Audit Trail">
          <i class="fa-solid fa-clipboard" style="font-size:18px;color:white"></i>
          <span class="reload_text text-white">Audit Trail</span>
        </div>
        <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="callReorderFunc()" (keydown.enter)="callReorderFunc()" matTooltip="Reorder Question">
          <img src="../../../assets/img/training_module/Order.svg" width="18px" height="18px" alt="reload" />
          <span class="reload_text">Reorder</span>
        </div>
        <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="refreshGrid()"
          (keydown.enter)="refreshGrid()" matTooltip="Refresh Grid">
          <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reload" />
          <span class="reload_text">Reload</span>
        </div>
      </div>
    </div>
  </div>

  <table class="dynamic-table-container documentTable">
    <th style="min-width: 60px;max-width: 60px; text-align: center;">
    </th>
    <th *ngFor="let column of columnList"
      [ngStyle]="{'min-width': column.width, 'max-width': column.width, 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
      <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
        <span>{{column.column}}</span>
        <div class="d-flex gap-2 align-items-center">
          <div>
            <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
          </div>
        </div>
      </div>
    </th>
    <tr *ngFor="let question of questionsList | searchFilter : searchValue; let idx = index;"
      (click)="openOptionsGrid(question)" (keydown.enter)="openOptionsGrid(question)">
      <td style="width: 60px; text-align: center;"
        [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
        <div style="display: flex;">
          <div [ngClass]="question.childCheckBoxs ?'static_icon':'hover-menu-icons'">
            <i class="fa-solid fa-ellipsis-vertical"></i>
          </div>
          <div>
            <input type="checkbox" style="zoom: 1.2;" [checked]="question.childCheckBoxs"
              (change)="dataGridChildCheckBoxChecked($event, question, idx)">
          </div>
        </div>
      </td>
      <td style="text-align: center;overflow: hidden;text-overflow: 'ellipsis';
      white-space: 'nowrap'"><span>{{question.seq}}</span></td>
      <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
       white-space: 'nowrap'"><span>{{question.question}}</span></td>
      <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
        white-space: 'nowrap'"><span>{{question.questionType1}}</span></td>
      <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
         white-space: 'nowrap'"><span>{{question.answer}}</span></td>
      <td class="sticky-col first-col">
        <div class="action-icons">
          <i class="fas fa-list-alt" matTooltip="Question Options" style="margin-left: 5px;"
            (click)="openOptionsPopup(question,$event)" (keydown.enter)="openOptionsPopup(question,$event)"></i>
          <i *ngIf="contentData.saveButtonForTraining || trainingData.status === 'Published'" class="fa-solid fa-pencil"
            matTooltip="Edit Question" style="margin-left: 5px;" (click)="editQuestionFunc(question,$event)"
            (keydown.enter)="editQuestionFunc(question,$event)"></i>
          <i *ngIf="contentData.saveButtonForTraining" class="fa-sharp fa-solid fa-trash" title="Delete"
            style="margin-left: 5px;" (click)="openDeletePopup(question,$event)"
            (keydown.enter)="openDeletePopup(question,$event)"></i>
          <i class="fa-solid fa-clipboard" *ngIf="message.isAuditTrailUser" matTooltip="Audit Trail"
            style="margin-left: 5px;" (click)="openAuditTrail('individual',question)"
            (keydown.enter)="openAuditTrail('individual',question)"></i>
        </div>
      </td>
    </tr>
  </table>
  <div class="d-flex justify-content-center">
    <div class="width-cheat small paginationCell">
      <div class="d-flex align-items-center gap-3">
        <div class="pagination_text mt-3">
          {{ showingRowsText }}
          1-{{ perPage }} of {{ collectionSize | number }}
        </div>
        <div>
          <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)" [disabled]="false"
            [collectionSize]="pager.totalItems" [(page)]="pager.currentPage" [maxSize]="maxSize" [rotate]="true"
            [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true" size="sm">
          </ngb-pagination>
        </div>
        <div ngbDropdown class="mt-3">
          <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasic1" ngbDropdownToggle>
            {{ perPage }}
            <i class="ms-1 fa-solid fa-chevron-down"></i>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
            <button ngbDropdownItem (click)="paginationCall(10)">10</button>
            <button ngbDropdownItem (click)="paginationCall(20)">20</button>
            <button ngbDropdownItem (click)="paginationCall(50)">50</button>
          </div>
          per page
        </div>
      </div>
    </div>
  </div>

</div>
<ng-template #addOrEditQuestionPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddAndEditFunction()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{title}}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="form-continer">
      <div class="row" style="margin-top: 1%;" *ngIf="!visibleEditButton">
        <div class="col-md-12">
          <mat-radio-group aria-label="Select an option" [(ngModel)]="fromSource" (change)="onTypeChanged(fromSource)">
            <mat-radio-button value="manually">Add Manually</mat-radio-button>
            <mat-radio-button value="fromFileUpload">From File Upload</mat-radio-button>
          </mat-radio-group>

        </div>
      </div>
      <div class="row" style="margin-top: 1%;" *ngIf="isFromFileUpload && questionMode != 'CREATE' && visibleAddButton">
        <div class="col-md-12">
          <mat-radio-group aria-label="Select an option" [(ngModel)]="questionMode"
            (change)="onModeChanged(questionMode)">
            <mat-radio-button value="REFRESH">Delete all questions and upload from file(Refresh)</mat-radio-button>
            <mat-radio-button value="MERGE">Add missing questions ( Merge)</mat-radio-button>
          </mat-radio-group>

        </div>
      </div>
      <div class="row" [hidden]="!isManually">
        <div class="col-md-3"><label for="question ">Question</label><span class="mandatory-symbol">*</span></div>
        <div class="col-md-9"> <textarea rows="6" id="question" class="input-filed-textarea" type="text"
            [(ngModel)]="questionData.question"></textarea>

        </div>
        <span style="margin-left: 25%;" id="question-required-msg">Please enter question</span>
      </div>
      <div class="row" [hidden]="!isManually">
        <div class="col-md-3"><label for="questionType">Answer Type</label><span class="mandatory-symbol">*</span></div>
        <div class="col-md-9">
          <mat-select id="questionType" matInput placeholder="Select" [(ngModel)]="selectedQuestionType"
            [ngClass]="{'odd-item-mat-select': oddQuestionType == selectedQuestionType}"
            (closed)="answerTypeSearchText=''" (click)="focusSearch('focus-answer-type-search')"
            (keydown.enter)="focusSearch('focus-answer-type-search')">
            <input type="search" id="focus-answer-type-search" class="dropdownsearchstyle"
              [(ngModel)]="answerTypeSearchText" matInput placeholder="search">
            <mat-option class="unselectStyle" (onSelectionChange)="onQuestionTypeSelect($event,null)"
              [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of questionTypeDropdown | assessmentSearch : answerTypeSearchText"
              (onSelectionChange)="onQuestionTypeSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <span style="margin-left: 25%;margin-top: 12px;" id="questionType-required-msg">Please enter answer type</span>
      </div>
      <br>
      <div class="row" [hidden]="!isManually">
        <div class="col-md-3"><label for="question ">Question Image</label></div>
        <div class="col-md-5">
          <span *ngIf="!clearedQuestionImage && questionImage">
            <p style="display: inline-block;">questionImage.{{questionData.questionImageExtn}}</p><i class="fa fa-close"
              (click)="removeImage()" (keydown.enter)="removeImage()"
              style="color: red;margin-left: 8px;font-size: 18px;"></i>
          </span>
          <input *ngIf="clearedQuestionImage || !questionImage" type="file" class="file-input"
            (change)="onFileSelected($event)" accept="image/*" #fileUploadForQuestion>
        </div>
        <div class="col-md-4" *ngIf="questionData.questionImage != null && questionImage">
          <div class="form-group row" style="margin-bottom:2%;">
            <img id="assessmentImageId" alt="question"
              [src]="'data:image/' + (questionData.questionImageExtn === 'jpg' ? 'jpeg' : questionData.questionImageExtn) + ';base64,' + questionData.questionImage"
              style="width:180px;height:50px; object-fit: contain;">
          </div>
        </div>
      </div>
      <div class="row" *ngIf="isFromFileUpload && visibleAddButton">
        <div class="col-md-2"><label for="question ">Upload File</label></div>
        <div class="col-md-8">
          <input type="file" class="file-input" (change)="onFileSelected($event)" #fileUploadForBulkQuestion>
        </div>
      </div>
      <br>
      <div class="row" *ngIf="visibleAddButton && isManually">
        <div class="col-md-3"><label for="answer ">Answer</label></div>
        <div class="col-md-9"> <input id="answer" class="input-filed-continers" type="text"
            [(ngModel)]="questionData.answer" disabled>
          <small>Note: Please add all choices after saving the question and come back to set the correct answer</small>
        </div>
      </div>
      <div class="row" *ngIf="visibleEditButton && isManually">
        <div class="col-md-3"><label for="answer ">Answer</label></div>
        <div class="col-md-9" *ngIf="questionData.questionType =='Check Box'">
          <mat-select matInput multiple placeholder="Select" #answer [(ngModel)]="selectedAnswer"
            (closed)="answerSearchText=''" (click)="focusSearch('focus-answer-search')"
            (keydown.enter)="focusSearch('focus-answer-search')">
            <input type="search" id="focus-answer-search" class="dropdownsearchstyle" [(ngModel)]="answerSearchText"
              matInput placeholder="search">
            <div class="select-all">
              <mat-checkbox [(ngModel)]="answerSelection" (change)="toggleAllSelection('answer')">
                Select All</mat-checkbox>
            </div>
            <mat-option *ngFor="let item of answerDropDown | assessmentSearch : answerSearchText"
              [value]="item.valueExp" (onSelectionChange)="onAnswerSelect($event,item)">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-9" *ngIf="questionData.questionType =='Radio Button'">
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedAnswer" (closed)="answerSearchText=''"
            (click)="focusSearch('focus-answer-search-2')" (keydown.enter)="focusSearch('focus-answer-search-2')">
            <input type="search" id="focus-answer-search-2" class="dropdownsearchstyle" [(ngModel)]="answerSearchText"
              matInput placeholder="search">
            <mat-option class="unselectStyle" (onSelectionChange)="onAnswerSelect($event,null)"
              [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of answerDropDown | assessmentSearch : answerSearchText"
              (onSelectionChange)="onAnswerSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>
      <br>
      <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="addAndEditFunction(questionData)" (keydown.enter)="addAndEditFunction(questionData)"
          *ngIf="!visibleEditButton">
          <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
          <span class="reload_text text-white">Add New</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          (click)="addAndEditFunction(questionData)" (keydown.enter)="addAndEditFunction(questionData)"
          *ngIf="visibleEditButton&& (contentData.saveButtonForTraining || trainingData.status === 'Published')">
          <i class=" fas fa-user-edit" style="font-size: 18px;color: white;"></i>
          <span class="reload_text text-white">Update</span>
        </div>
        <button mat-stroked-button class="cancelButton" (click)="cancelAddAndEditFunction()">
          <i class="fa fa-close"></i> Cancel
        </button>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #deleteQuestionPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <h2 mat-dialog-title>{{title }}</h2>
  <div style="margin: 15px 15px;">
    <div class="form-continer">
      <div class="row">
        <div class="col-md-12">
          <div><label for="deleteReason"> Reason</label><span class="mandatory-symbol">*</span></div>
          <textarea id="deleteReason" rows="6" class="textarea-filed-continers" type="text"
            [(ngModel)]="questionData.deleteReason"></textarea>
          <span id="deleteReason-required-msg">Please enter reason for delete</span>
        </div>
      </div>
      <br>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="deleteButton" (click)="deleteFunction()">
        <i class="fa fa-trash"></i> Delete
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelDeleteFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #reorderQuestionPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelReorderFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{title}}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;">
    <b>Drag and drop to reorder the assessment sequence</b>
    <div class="table-container" style="max-height: 150vh; overflow-y: auto;">
      <table class="dynamic-table-container">
        <th style="width: 80px; text-align: center;overflow: hidden;text-overflow: 'ellipsis';
        white-space: 'nowrap'"> <span>Content Seq</span> <span class="grid-header-container"></span> </th>
        <th style="width: 240px; text-align: left;overflow: hidden;text-overflow: 'ellipsis';
        white-space: 'nowrap'"> <span>Name</span> <span class="grid-header-container"></span> </th>
        <th style="width: 80px; text-align: left;overflow: hidden;text-overflow: 'ellipsis';
        white-space: 'nowrap'"> <span>New Seq</span> <span class="grid-header-container"></span> </th>

        <tbody cdkDropList (cdkDropListDropped)="drop($event)">
          <tr cdkDrag cdkDragLockAxis="y" cdkDragHandle *ngFor="let question of reorderQuestionsList let idx = index;">
            <td style="text-align: center;overflow: hidden;text-overflow: 'ellipsis';
          white-space: 'nowrap'"><span>{{question.seq}}</span></td>
            <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
           white-space: 'nowrap'"><span>{{question.question}}</span></td>
            <td style="text-align: left;overflow: hidden;text-overflow: 'ellipsis';
            white-space: 'nowrap'"><span>{{question.newSeq}}</span></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="addButton" (click)="reorderQuestionFunction()">
        <i class="fa fa-redorder"></i> Reorder
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelReorderFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #questionOptionPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelOptionPopup()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> Question Options - {{questionData.seq}}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="form-continer">
      <div class="row">
        <app-assessment-option [questionData]="questionData"></app-assessment-option>
      </div>
    </div>
  </div>
</ng-template>

<app-static-audit-trail #auditTrailPopup></app-static-audit-trail>
<app-excel-pdf #excelPdfPopup [excelPdf]="excelPdf"></app-excel-pdf>